/** ステップ5: 完了 (req9 表示)。注文サマリを表示し状態を提示 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { purchaseApi, type Order } from '../api/purchaseApi';
import { loadState, clearState } from '../state/purchaseState';
import { yen, annualExcludedOfItem, annualIncludedOfItem, firstPayBreakdownItem, contractBreakdownItem } from '../state/calc';
import { sortByServiceOrder } from '../serviceOrder';
import { PurchaseLayout } from './PurchaseLayout';

export const PurchaseCompletePage: React.FC = () => {
  const nav = useNavigate();
  const [order, setOrder] = useState<Order | null>(null);

  useEffect(() => {
    const st = loadState();
    if (!st.orderId) { nav('/purchase'); return; }
    purchaseApi.getOrder(st.orderId).then((r) => { setOrder(r.order); clearState(); });
  }, []);

  if (!order) return <PurchaseLayout step={4} sectionTitle="完了"><p>読み込み中…</p></PurchaseLayout>;
  const bc = order.billingCompany;

  return (
    <PurchaseLayout step={4} sectionTitle="完了" sectionSub="お申し込みを受け付けました">
      <div className="pf-form">
        <div className="pf-ok">
          お申し込みありがとうございます。お申し込みを受け付けました。<br />
          ご登録のメールアドレス宛に、ログイン用の<b>仮パスワード</b>を記載したメールをお送りしました。ログインID（メールアドレス）と仮パスワードでログインのうえ、初回にパスワードのご変更をお願いします。万が一メールが届かない場合は、迷惑メールフォルダもご確認ください。
        </div>

        <h3 style={{ fontSize: 15, margin: '10px 0 6px' }}>契約者情報</h3>
        {bc && <div style={{ fontSize: 14, lineHeight: 1.9 }}>{bc.name}<br />〒{bc.zip} {bc.address}<br />TEL {bc.tel}<br />代表者：{bc.presidentName} 様（{bc.email}）</div>}

        {(() => {
          const items = sortByServiceOrder(order.items, (i) => i.productCode);
          const firstExcl = items.reduce((s, i) => s + i.amountExcluded, 0);
          const firstIncl = items.reduce((s, i) => s + i.amountIncluded, 0);
          const contractExcl = items.reduce((s, i) => s + annualExcludedOfItem(i), 0);
          const contractIncl = items.reduce((s, i) => s + annualIncludedOfItem(i), 0);
          return (
            <>
              <h3 style={{ fontSize: 15, margin: '14px 0 6px' }}>1回目支払い内容</h3>
              {items.map((i) => (
                <div className="pf-sum-row" key={i.id}>
                  <span>{i.productName}（{firstPayBreakdownItem(i)}）× {i.userCount}名</span>
                  <span>{yen(i.amountExcluded)}</span>
                </div>
              ))}
              <div className="pf-sum-row"><span>小計</span><span>{yen(firstExcl)}</span></div>
              <div className="pf-sum-row"><span>消費税</span><span>{yen(firstIncl - firstExcl)}</span></div>
              <div className="pf-sum-row" style={{ fontWeight: 700 }}><span>合計</span><span>{yen(firstIncl)}</span></div>

              <h3 style={{ fontSize: 15, margin: '18px 0 6px' }}>契約内容</h3>
              {items.map((i) => (
                <div className="pf-sum-row" key={`c-${i.id}`}>
                  <span>{i.productName}（{contractBreakdownItem(i)}）× {i.userCount}名</span>
                  <span>{yen(annualExcludedOfItem(i))}</span>
                </div>
              ))}
              <div className="pf-sum-row"><span>小計</span><span>{yen(contractExcl)}</span></div>
              <div className="pf-sum-row"><span>消費税</span><span>{yen(contractIncl - contractExcl)}</span></div>
              <div className="pf-sum-row" style={{ fontWeight: 700 }}><span>合計</span><span>{yen(contractIncl)}</span></div>
            </>
          );
        })()}

        <div className="pf-actions">
          <button className="go" onClick={() => nav('/purchase')}>トップへ戻る</button>
        </div>
      </div>
    </PurchaseLayout>
  );
};

export default PurchaseCompletePage;
